<script setup>
const navigation = {
  main: [
    { name: 'About', href: 'https://railops.app' },
    { name: 'Docs', href: 'https://railops.app/docs' },
  ],
}
</script>

<template>
  <footer class="">
    <div class="mx-auto mt-24 max-w-7xl overflow-hidden px-6 py-10 sm:py-12 lg:px-8">
      <nav class="-mb-6 flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/6" aria-label="Footer">
        <a v-for="item in navigation.main" :key="item.name" :href="item.href" class="text-gray-600 hover:text-gray-900">{{ item.name }}</a>
      </nav>

      <p class="mt-10 text-center text-sm/6 text-gray-600">
        &copy; {{ new Date().getFullYear() }} InternetMill LLC. All rights reserved.
      </p>
    </div>
  </footer>
</template>
